import { createPortal } from "react-dom"
import Div from "../Div"
import Form from "../Form"
import FormButton from "../FormButton"
import Select from "../Select"
import {
    highlight, comment_status, aggrement_status, yesno, sub_reason, reason,
    suspension_reason, support_packages, managed_service_type, managed_service_price,
    support_frequency
} from "../../util/enum"
import Input from "../Input"
import { useCallback, useEffect, useState } from "react"
import { insertComments, getRenewalDomainDetails } from "../../http/renewalHttp/RenewalHttp"
import { getAllProducts } from "../../http/ProductsHttp"


export default function AddCommentModal({ type, comments, handleClicked, ...props }) {

    const [showZohoForm, setShowZohoForm] = useState(false);
    const [confirmOption, setConfirmOption] = useState(false)
    const [products, setProducts] = useState([])
    const [renewalDomain, setRenewalDomain] = useState()
    const [renewalDate, setRenewalDate] = useState(null)
    const [priceType, setPriceType] = useState('price'); // 'price' or 'split_price'
    const [licenseRange, setLicenseRange] = useState(null)
    const [showPlanName, setShowPlanName] = useState(false); // State to control Plan Name visibility
    const [supportType, setSupportType] = useState('support')

    const getRenewalDomainData = useCallback(async () => {
        const response = await getRenewalDomainDetails(comments)
        setRenewalDomain(response.domain[0])
        const originalRenewalDate = new Date(response.domain[0].shivaami_renewal_date);
        const newRenewalDate = new Date(originalRenewalDate);
        newRenewalDate.setDate(originalRenewalDate.getDate() + 365);
        const formattedDate = newRenewalDate.toISOString().split('T')[0];
        setRenewalDate(formattedDate)
    }, [comments])

    useEffect(() => {
        getRenewalDomainData()
    }, [getRenewalDomainData])

    const status = aggrement_status.status.map((highlight) =>
        highlight.id !== comments ?
            <option key={highlight.id}
                name={highlight.id}
                value={highlight.id}>
                {highlight.value}</option>
            : null);

    const support_package = support_packages.support_packages.map((highlight) =>
        highlight.id !== comments ?
            <option key={highlight.id}
                name={highlight.id}
                value={highlight.id} >{highlight.value}</option> : null)

    const suspension_reasons = suspension_reason.reason.map((reason) =>
        <option key={reason.id}
            name={reason.id}
            value={reason.id}>
            {reason.value}
        </option>
    )

    const sub_reasons = sub_reason.sub_reasons.map(sub_reason =>
        sub_reason.id !== comments ?
            <option key={sub_reason.id}
                name={sub_reason.id}
                value={sub_reason.id}>
                {sub_reason.value}</option>
            : null)

    const support_frequencies = support_frequency.support_frequency.map(sub_reason =>
            <option key={sub_reason.id}
                name={sub_reason.id}
                value={sub_reason.id}>
                {sub_reason.value}</option>)

    const reasons = reason.reasons.map(reason =>
        reason.id !== comments ?
            <option key={reason.id}
                name={reason.id}
                value={reason.id}>
                {reason.value}</option>
            : null)

    const highlights = highlight.comment.map((highlight) =>
        highlight.id !== comments ?
            <option key={highlight.id}
                name={highlight.id}
                value={highlight.id}>
                {highlight.value}</option>
            : null);

    const comments_status = comment_status.status.map((highlight) =>
        highlight.id !== comments ?
            <option key={highlight.id}
                name={highlight.id}
                value={highlight.value}>
                {highlight.value}</option>
            : null);

    const options = yesno.options.map((highlight) =>
        highlight.id !== comments ?
            <option key={highlight.id}
                name={highlight.id}
                value={highlight.id}>
                {highlight.value}</option>
            : null);

    const managed_service_types = managed_service_type.managed_service_type.map((highlight) =>
        highlight.id !== comments ?
            <option key={highlight.id}
                name={highlight.id}
                value={highlight.id}>
                {highlight.value}</option>
            : null);

    const managed_service_prices = managed_service_price.managed_service_price.map((highlight) =>
        highlight.id !== comments ?
            <option key={highlight.id}
                name={highlight.id}
                value={highlight.id}>
                {highlight.value}</option>
            : null);


    const getProducts = async () => {
        const response = await getAllProducts()
        const products = response.products.map((product) =>
            <option key={product.productname}
                name={product.productname}
                value={product.productname}>
                {product.productname}</option>)

        setProducts(products)
    }

    useEffect(() => {
        getProducts()
    }, [])

    function handleClose() {
        handleClicked(false)
    }

    // function handleLicenseAdd(license) {
    //     // setLicenseAdded(license)
    // }

    function handleRenewalDateChange(date) {
        setRenewalDate(date)
    }

    const handleShowPlanNameChange = (event) => {
        setShowPlanName(event.target.checked);
    };

    const handlePriceTypeChange = (event) => {
        setPriceType(event.target.value);
        setLicenseRange(null)
        console.log(licenseRange)

    };

    const handleSupportTypeChange = (event) => {
        setSupportType(event.target.value);
    }
    // const handleLicenseRangeChange = (e) => {
    //     setLicenseRange(e.target.value)
    // }

    const handleUpdateSelect = (renewal_id, field, value) => {

        // if (field === 'highlight') {
        //     // updatehighlight
        // }
        // else if (field === 'status') {
        //     // update status 
        //     if (value === 'Confirmation Received' || value === 'Partial Upgrade' || value === 'Mid Term Upgrade' || value === 'Confirmation received for flex' || value === 'Upgrade') {
        //         const addedStatus = <>
        //             <Div className='row'>
        //                 <label>Plan Name</label>
        //                 <Div className="form-group">
        //                     <Select name='com_plan_name'
        //                         options={products} defaultValue='Select Product'
        //                         className="form-control" />
        //                 </Div>

        //             </Div>

        //             <Div className='row'>
        //                 <label>Next Renewal Date</label>
        //                 <Div className="form-group">
        //                     <Input name='com_next_renewal_date'
        //                         onChange={(e) => handleRenewalDateChange(e.target.value)}
        //                         value={renewalDate}
        //                         type="date" className="form-control" placeholder="Enter Next Renewal Date" />
        //                 </Div>

        //             </Div>

        //             <Div className='row'>
        //                 <label>No . of License</label>
        //                 <Div className="form-group">
        //                     <Input name='add_lic'
        //                         // onChange={(e) => handleLicenseAdd(e.target.value)}
        //                         // value={licenseAdded}
        //                         type="text" className="form-control" placeholder="Enter No. of License" />
        //                 </Div>

        //             </Div>

        //             <Div className='row'>
        //                 <label>Task Given</label>
        //                 <Div className="form-group">
        //                     <Select name='task_status' options={options} defaultValue={comments.zone}
        //                         // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'task_given', e.target.value)}

        //                         style={{ width: 'auto' }} />
        //                 </Div>

        //             </Div>

        //             {/* {licenseAdded > 100 ?  */}
        //             <Div className='row'>
        //                 <label>Aggrement Status</label>
        //                 <Div className="form-group">
        //                     <Select name='aggrement' options={status} defaultValue={comments.zone}
        //                         // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

        //                         style={{ width: 'auto' }} />
        //                 </Div>
        //             </Div>

        //             <Div className='row'>
        //                 <label>Renewed Price</label>
        //                 <Div className="form-group">
        //                     <Input name='price'
        //                         // onChange={(e) => setLicenseAdded(e.target.value)}
        //                         type="text" className="form-control" placeholder="Enter Renewed Price" />
        //                 </Div>
        //             </Div>

        //             <Div className='row'>
        //                 <label>Support Charges</label>
        //                 <Div className="form-group">
        //                     <Input name='support_price'
        //                         type="text" className="form-control" placeholder="Enter Support Price"
        //                         style={{ width: 'auto' }} />
        //                 </Div>

        //             </Div>

        //         </>

        //         setConfirmOption(addedStatus)
        //     }
        //     else if (value === 'Extension') {
        //         const addedStatus = <>
        //             <Div className='row'>
        //                 <label>Extension Date</label>
        //                 <Div className="form-group">
        //                     <Input text='' name='extension_date'
        //                         // onChange={(e) => setLicenseAdded(e.target.value)}
        //                         type="date" className="form-control" placeholder="Enter Reason" />
        //                 </Div>
        //             </Div>
        //         </>

        //         setConfirmOption(addedStatus)
        //     }
        //     else if (value === 'Lost') {
        //         setConfirmOption(<>
        //             <Div className='row'>
        //                 <label>Reason</label>
        //                 <Div className="form-group">
        //                     <Select name='reason' options={reasons} defaultValue='Select Lost Reason'
        //                     />
        //                 </Div>
        //             </Div>
        //             <Div className='row'>
        //                 <label>Sub Reason</label>
        //                 <Div className="form-group">
        //                     <Select name='sub_reason' options={sub_reasons} defaultValue='Select Lost Sub Reason' />
        //                 </Div>
        //             </Div>

        //         </>)

        //         // setConfirmOption(addedStatus)
        //     }
        //     else {
        //         setConfirmOption(false)
        //     }

        if (field === 'highlight') {
            return
        }

        if (field === 'status') {
            if (["Confirmation Received", "Partial Upgrade", "Mid Term Upgrade", "Confirmation received for flex", "Upgrade"].includes(value)) {
                setConfirmOption('confirmation')
            } else if (value === 'Extension') {
                setConfirmOption('extension')
            } else if (['Lost'].includes(value)) {
                setConfirmOption('lost')
            } else if (['Suspended'].includes(value)) {
                setConfirmOption('suspended')
            } else {
                setConfirmOption('')
            }
        }
    };


    async function handleSubmit(event) {
        event.preventDefault();
        const forgetFD = new FormData(event.target);
        const data = Object.fromEntries(forgetFD.entries());

        // --- Existing Validation Logic ---

        if (data.highlight === '') {
            alert('Highlight cannot be Blank');
            return false;
        }
        if (data.status === '') {
            alert('Status cannot be Blank');
            return false;
        }
        if (data.status === 'Confirmation Received'
            || data.status === 'Partial Upgrade'
            || data.status === 'Mid Term Upgrade'
            || data.status === 'Confirmation received for flex'
            || data.status === 'Upgrade') {

            if (data.add_lic === '') {
                alert('Enter License Added');
                return false;
            }

            if (parseInt(data.add_lic) > 99 && data.aggrement === '') {
                alert('Aggrement cannot be Blank for more than 100 license');
                return false;
            }
            if (showPlanName && data.com_plan_name === undefined) {
                alert("Please Select Plan Name");
                return false;
            }
            if (priceType === 'split_price') {
                // if (!licenseRange) {
                //     alert('Select a license range');
                //     return false;
                // }
            }
        }

        if (data.status === 'Lost') {
            if (data.reason === '') {
                alert('Enter Reason');
                return false;
            } else if (data.sub_reason === '') {
                alert('Enter Sub Reason');
                return false;
            }
        }
        if (data.status === 'Extension') {
            if (data.extension_date === '') {
                alert('Enter Extension Date');
                return false;
            }
        }

        // --- Task Given Validation (If 'Task Given' is 'Yes') ---
        if (data.task_status === 'Yes') {
            if (!data.subject || data.subject.trim() === '') { // <-- Renamed to data.subject
                alert('Subject is required when Task Given is Yes');
                return false;
            }
            if (!data.description || data.description.trim() === '') { // <-- Renamed to data.description
                alert('Description is required when Task Given is Yes');
                return false;
            }
        }
        // -----------------------------------------------------------


        if (!data.com_plan_name) {
            data.com_plan_name = renewalDomain.skuName;
        }

        console.log(data, comments);

        // --- 1. Attempt to Insert/Update Renewal Comment (Original Action) ---
        const response = await insertComments(data, comments); 

        console.log("Insert Comments Response:", response);

        // let taskSuccess = true; // Use 'taskSuccess' instead of 'zohoTaskSuccess'

        // --- 2. Conditionally Create Task (Non-Zoho) ---
        // if (data.task_status === 'Yes') {
        //     const taskData = {
        //         subject: data.subject, // Use generic field names
        //         description: data.description 
        //     };

            // // ⚠️ Call the generic createTask function
            // const taskResponse = await createTask(taskData); 
            
            // if (!taskResponse || taskResponse.error === true) { // Check for failure from placeholder
            //     taskSuccess = false;
            //     alert('Error: Failed to create Task. Please check logs.');
            //     console.error('Task Creation Failed:', taskResponse);
            // } else {
            //     console.log("Task created successfully:", taskResponse);
            // }
        // }
        // ------------------------------------------

        // --- 3. Finalize and Reload ---
        if (response) {
            window.location.reload();
        } else if (!response) {
            // Handle case where comment failed but task succeeded (unlikely, but safe)
            alert('Comment update failed, but Task was created. Reloading...');
            window.location.reload();
        }

    }

    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', maxWidth: '100%', overflow: 'auto' }}>
                        <Div className="modal-content" style={{ padding: '20px' }}>
                            <Div className="form-group">
                                Add Comments
                            </Div>
                            <Form onSubmit={handleSubmit} >
                                <Div className="form-group" >

                                    <Div className='row'>
                                        <label>Highlighted Case</label>
                                        <Div className="form-group">
                                            <Select name='highlight' options={highlights} defaultValue={comments.zone}
                                                onChange={(e) => handleUpdateSelect(comments.renewal_id, 'highlight', e.target.value)}

                                                style={{ width: 'auto' }} />
                                        </Div>

                                    </Div>

                                    <Div className='row'>
                                        <label>Status</label>
                                        <Div className="form-group">
                                            <Select name='status' options={comments_status} defaultValue={comments.zone}
                                                onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

                                                style={{ width: 'auto' }} />
                                        </Div>

                                    </Div>

                                    {confirmOption === 'confirmation' && (
                                        <>
                                            <Div className="row" margin={{ marginLeft: 'auto' }}>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="showPlanName"
                                                        checked={showPlanName}
                                                        onChange={handleShowPlanNameChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="showPlanName">
                                                        Show Plan Name
                                                    </label>
                                                </div>
                                            </Div>
                                            {showPlanName && (
                                                <Div className='row'>
                                                    <label>Plan Name</label>
                                                    <Div className="form-group">
                                                        <Select name='com_plan_name'
                                                            options={products} defaultValue='Select Product'
                                                            className="form-control" />
                                                    </Div>
                                                </Div>)}

                                            <Div className='row'>
                                                <label>Next Renewal Date</label>
                                                <Div className="form-group">
                                                    <Input name='com_next_renewal_date'
                                                        onChange={(e) => handleRenewalDateChange(e.target.value)}
                                                        value={renewalDate}
                                                        type="date" className="form-control" placeholder="Enter Next Renewal Date" />
                                                </Div>
                                            </Div>

                                            <Div className='row'>
                                                <label>No. of License</label>
                                                <Div className="form-group">
                                                    <Input name='add_lic'
                                                        type="text" className="form-control" placeholder="Enter No. of License" />
                                                </Div>
                                            </Div>

                                            <Div className='row'>
                                                <label>Task Given</label>
                                                <Div className="form-group">
                                                    <Select
                                                        name='task_status'
                                                        options={options}
                                                        defaultValue={comments.zone}
                                                        onChange={(e) => {
                                                            handleUpdateSelect(comments.renewal_id, 'task_given', e.target.value); 
                                                            if (e.target.value === 'Yes') {
                                                                setShowZohoForm(true);
                                                            } else {
                                                                setShowZohoForm(false);
                                                            }
                                                        }}
                                                        style={{ width: 'auto' }}
                                                    />
                                                </Div>
                                            </Div>
                                            
                                            {/* UPDATED: Conditional Task Input Fields (non-Zoho specific labels) */}
                                            {showZohoForm && ( 
                                                <>
                                                    <Div className='row'>
                                                        <label>Subject</label>
                                                        <Div className="form-group">
                                                            {/* Renamed input name to generic 'subject' */}
                                                            <Input name='subject' 
                                                                type="text" className="form-control" placeholder="Enter Subject"
                                                                style={{ width: 'auto' }} />
                                                        </Div>
                                                    </Div>
                                                    <Div className='row'>
                                                        <label>Description</label>
                                                        <Div className="form-group">
                                                            {/* Renamed textarea name to generic 'description' */}
                                                            <textarea name='description'
                                                                className="form-control" rows="3" placeholder="Enter Description"
                                                                style={{ opacity: '0.8' }}
                                                            ></textarea>
                                                        </Div>
                                                    </Div>
                                                </>
                                            )}

                                            {/* {licenseAdded > 100 ?  */}
                                            <Div className='row'>
                                                <label>Aggrement Status</label>
                                                <Div className="form-group">
                                                    <Select name='aggrement' options={status}
                                                        defaultValue={parseInt(renewalDomain.maxSeats) < 100 ? 'N/A' : ''}
                                                        // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

                                                        style={{ width: 'auto' }} />
                                                </Div>
                                            </Div>

                                            <Div className="row">
                                                <label>Price Type</label>
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="priceType"
                                                            id="price"
                                                            value="price"
                                                            checked={priceType === 'price'}
                                                            onChange={handlePriceTypeChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="price">
                                                            Price
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="priceType"
                                                            id="split_price"
                                                            value="split_price"
                                                            checked={priceType === 'split_price'}
                                                            onChange={handlePriceTypeChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="split_price">
                                                            Split Price
                                                        </label>
                                                    </div>
                                                </div>
                                            </Div>
                                            {priceType === 'price' && (
                                                <Div className='row'>
                                                    <label>Renewed Price</label>
                                                    <Div className="form-group">
                                                        <Input name='price'
                                                            // onChange={(e) => setLicenseAdded(e.target.value)}
                                                            type="number" className="form-control" placeholder="Enter Renewed Price" />
                                                    </Div>
                                                </Div>
                                            )}
                                            {priceType === 'split_price' && (
                                                <Div className="row">
                                                    <label>License Range</label>
                                                    <div className="form-group">
                                                        <div className="form-check form-check-inline">
                                                            {/* <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="licenseRange"
                                                                id="upto20"
                                                                value="upto20"
                                                                checked={licenseRange === 'upto20'}
                                                                onChange={handleLicenseRangeChange}
                                                            /> */}
                                                            <label className="form-check-label" htmlFor="upto20">
                                                                Upto 20
                                                            </label>
                                                            <Input name='upto20'
                                                                // onChange={(e) => setLicenseAdded(e.target.value)}
                                                                type="number" className="form-control" placeholder="Enter Upto 20 Price" />
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            {/* <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="licenseRange"
                                                                id="above20"
                                                                value="above20"
                                                                checked={licenseRange === 'above20'}
                                                                onChange={handleLicenseRangeChange}
                                                            /> */}
                                                            <label className="form-check-label" htmlFor="above20">
                                                                Above 20
                                                            </label>
                                                            <Input name='above20'
                                                                // onChange={(e) => setLicenseAdded(e.target.value)}
                                                                type="number" className="form-control" placeholder="Enter Above 20 Price" />
                                                        </div>

                                                        <Div className='row'>
                                                            {/* <label>Renewed Price</label>
                                                    <Div className="form-group">
                                                        <Input name='price'
                                                            // onChange={(e) => setLicenseAdded(e.target.value)}
                                                            type="text" className="form-control" placeholder="Enter Renewed Price" />
                                                    </Div> */}
                                                        </Div>
                                                    </div>
                                                </Div>

                                            )}

                                             <Div className='row'>
                                                <label className>Default Payers</label>
                                                <Div className="form-group">
                                                    <Select
                                                        name='default_payers'
                                                        options={[
                                                            <option key="yes" value="Yes">Yes</option>,
                                                            <option key="no" value="No">No</option>
                                                        ]}
                                                        defaultValue=""
                                                        style={{ width: '100%' }}
                                                    />
                                                </Div>
                                            </Div>

                                            <Div className='row'>
                                                <label>Support Packages</label>
                                                <Div className="form-group">
                                                    <Select name='support_package' options={support_package}
                                                        defaultValue='Select Support Package'
                                                        // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

                                                        style={{ width: 'auto' }} />
                                                </Div>
                                            </Div>


                                            <Div className="row">
                                                <label>Support Type</label>
                                                <div className="form-group">
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="supportType"
                                                            id="support"
                                                            value="support"
                                                            checked={supportType === 'support'}
                                                            onChange={handleSupportTypeChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="support">
                                                            Support Charge
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="supportType"
                                                            id="managed_service"
                                                            value="managed_service"
                                                            checked={supportType === 'managed_service'}
                                                            onChange={handleSupportTypeChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="managed_service">
                                                            Managed Service
                                                        </label>
                                                    </div>
                                                </div>
                                            </Div>

                                            {supportType === 'support' && (
                                                <Div className='row'>
                                                    <label>Support Charges</label>
                                                    <Div className="form-group">
                                                        <Input name='support_price'
                                                            type="number" className="form-control" placeholder="Enter Support Price"
                                                            style={{ width: 'auto' }} />
                                                        <Select name='support_frequency' options={support_frequencies}
                                                                defaultValue='Select Support Period'
                                                                // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

                                                                style={{ width: 'auto' }} />

                                                        
                                                    </Div>

                                                </Div>)}

                                            {supportType === 'managed_service' && (
                                                <>
                                                    <Div className='row'>

                                                        <label>Managed Service Start Date</label>
                                                        <Div className="form-group">
                                                            <Input name='managed_service_start_date' 
                                                                type = "date"  className="form-control" 
                                                                id = "managed_service_start_date"
                                                                // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

                                                                style={{ width: 'auto' }} />

                                                        </Div>

                                                    </Div>

                                                    <Div className='row'>

                                                        <label>Managed Service End Date</label>
                                                        <Div className="form-group">
                                                            <Input name='managed_service_end_date'
                                                                type = "date"  className="form-control" 
                                                                id = "managed_service_end_date"
                                                                // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

                                                                style={{ width: 'auto' }} />

                                                        </Div>

                                                    </Div>

                                                    <Div className='row'>

                                                        <label>Managed Service Price Type</label>
                                                        <Div className="form-group">
                                                            <Select name='managed_service_price' options={managed_service_prices}
                                                                defaultValue='Select Managed Service Type'
                                                                // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

                                                                style={{ width: 'auto' }} />

                                                        </Div>

                                                    </Div>
                                                    <Div className='row'>

                                                        <label>Type of Managed Service</label>
                                                        <Div className="form-group">
                                                            <Select name='managed_service_type' options={managed_service_types}
                                                                defaultValue='Select Managed Service Type'
                                                                // onChange={(e) => handleUpdateSelect(comments.renewal_id, 'status', e.target.value)}

                                                                style={{ width: 'auto' }} />

                                                        </Div>

                                                    </Div>
                                                </>
                                            )}

                                        </>
                                    )}

                                    {confirmOption === 'extension' && (
                                        <Div className='row'>
                                            <label>Extension Date</label>
                                            <Div className="form-group">
                                                <Input name='extension_date'
                                                    type="date" className="form-control" placeholder="Enter Extension Date" />
                                            </Div>
                                        </Div>
                                    )}

                                    {confirmOption === 'lost' && (
                                        <>
                                            <Div className='row'>
                                                <label>Reason</label>
                                                <Div className="form-group">
                                                    <Select name='reason' options={reasons} defaultValue='Select Lost Reason' />
                                                </Div>
                                            </Div>
                                            <Div className='row'>
                                                <label>Sub Reason</label>
                                                <Div className="form-group">
                                                    <Select name='sub_reason' options={sub_reasons} defaultValue='Select Lost Sub Reason' />
                                                </Div>
                                            </Div>
                                            <Div className='row'>
                                                <label>Lost Comment</label>
                                                <Div className="form-group">
                                                    <textarea
                                                        name='lost_comment'
                                                        className="form-control"
                                                        rows="2"
                                                        placeholder="Enter additional details about why this was lost"
                                                    ></textarea>
                                                </Div>
                                            </Div>
                                        </>
                                    )}

                                    {confirmOption === 'suspended' && (
                                        <>
                                            <Div className='row'>
                                                <label>Reason</label>
                                                <Div className="form-group">
                                                    <Select name='suspend_reason' options={suspension_reasons} defaultValue='Select Suspension Reason' />
                                                </Div>
                                            </Div>
                                            <Div className='row'>
                                                <label>Sub Reason</label>
                                                <Div className="form-group">
                                                    <Input type="text" className="form-control" placeholder="Enter Suspension Reason"
                                                        style={{ width: 'auto' }} name='suspend_reason_text' />
                                                </Div>
                                            </Div>
                                        </>
                                    )
                                    }


                                    <Div className='row'>

                                        <Div className='col-sm-6'>
                                            <FormButton type='submit' style={{ margin: '2px' }}
                                                className="btn btn-primary submit-btn btn-block" >Save</FormButton>
                                        </Div>
                                        <Div className='col-sm-6'>
                                            <FormButton type='button' style={{ margin: '2px' }} onClick={handleClose}
                                                className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                        </Div>
                                    </Div>

                                </Div>

                            </Form>
                        </Div>
                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }

        </>
    )
}